var _circle, _circle2, _g, _circle3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexusError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 133,
    viewBox: "0 0 119 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 69.5,
    r: 45.5,
    fill: "#F25041"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "url(#paint0_linear_599_4320)",
    stroke: "url(#paint1_linear_599_4320)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 49.1093V23.7284H23.2555L40.9783 40.9408V23.7284H42.3276V49.1093H40.9783V42.837L23.1825 25.4788V49.1093H21.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1075 17.6607L33.9378 15.8304L32.1075 14L30.2771 15.8304L32.1075 17.6607Z",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 101,
    r: 31.5,
    fill: "url(#paint2_linear_599_4320)",
    stroke: "url(#paint3_linear_599_4320)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip1_599_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2974 106.5C92.7847 106.499 92.2787 106.383 91.8163 106.162C91.3539 105.941 90.9468 105.619 90.6245 105.22C90.3022 104.821 90.0729 104.356 89.9533 103.857C89.8337 103.359 89.8268 102.84 89.9332 102.338C90.1061 101.551 90.5452 100.848 91.1765 100.347C91.8077 99.8459 92.5924 99.578 93.3982 99.5883H95.589C95.7106 99.5883 95.8272 99.54 95.9131 99.4541C95.9991 99.3681 96.0474 99.2516 96.0474 99.13V97.0675C96.0449 96.4605 95.8027 95.879 95.3735 95.4497C94.9442 95.0205 94.3627 94.7782 93.7557 94.7758H80.9224C80.74 94.7758 80.5652 94.7034 80.4362 94.5745C80.3073 94.4455 80.2349 94.2707 80.2349 94.0883C80.2349 93.906 80.3073 93.7311 80.4362 93.6022C80.5652 93.4733 80.74 93.4008 80.9224 93.4008H93.0682C93.129 93.4008 93.1873 93.3767 93.2302 93.3337C93.2732 93.2907 93.2974 93.2324 93.2974 93.1717V92.9792C93.2974 91.7142 91.8582 90.6875 90.089 90.6875H80.0057C79.5844 90.6875 79.1672 90.7705 78.7779 90.9317C78.3887 91.093 78.035 91.3293 77.7371 91.6272C77.1354 92.2289 76.7974 93.0449 76.7974 93.8958V108.104C76.7974 108.955 77.1354 109.771 77.7371 110.373C78.035 110.671 78.3887 110.907 78.7779 111.068C79.1672 111.23 79.5844 111.312 80.0057 111.312H93.7557C94.0566 111.312 94.3546 111.253 94.6327 111.138C94.9107 111.023 95.1633 110.854 95.3762 110.641C95.589 110.428 95.7578 110.176 95.8729 109.898C95.9881 109.62 96.0474 109.322 96.0474 109.021V106.729C96.0474 106.668 96.0232 106.61 95.9802 106.567C95.9373 106.524 95.879 106.5 95.8182 106.5H93.2974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0471 101H93.2971C92.7501 101 92.2255 101.217 91.8387 101.604C91.4519 101.991 91.2346 102.515 91.2346 103.062C91.2346 103.61 91.4519 104.134 91.8387 104.521C92.2255 104.908 92.7501 105.125 93.2971 105.125H96.0471C96.3708 105.07 96.6642 104.902 96.8744 104.649C97.0845 104.397 97.1975 104.078 97.193 103.75V102.375C97.1975 102.047 97.0845 101.728 96.8744 101.476C96.6642 101.223 96.3708 101.055 96.0471 101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_599_4320",
    x1: 32,
    y1: 43.978,
    x2: 32,
    y2: 73.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_599_4320",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_599_4320",
    x1: 87,
    y1: 58,
    x2: 87,
    y2: 142.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_599_4320",
    x1: 87,
    y1: 69,
    x2: 87,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_4320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 35.1429,
    fill: "white",
    transform: "translate(21.8335 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_599_4320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(76 90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusError);
export default __webpack_public_path__ + "static/media/nexus-error.6a9aa0a67a7d0964733a6dd812a00374.svg";
export { ForwardRef as ReactComponent };